import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import {
    LoginPage,
    Form,
    FormGroup,
    TextInput,
    Button,
    Alert,
    Split,
    SplitItem
} from "@patternfly/react-core";
import backgroundImg from 'shared/assets/images/svg/pf-background.svg';

const PasswordResetRequestPage = (props) => {
  const [value, setValue] = useState("");
  const [helperText, setHelperText] = useState("");
  const [showHelperText, setShowHelperText] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Wyślij link resetujący");
  const [success, setSuccess] = useState(false); // ✅ stan powodzenia
  const currentUrl = window.location.href;
  
  const obfuscateEmail = (email) => {
    if (!email) return "";

    const [name, domain] = email.split("@");
    if (!name || !domain) return email;

    if (name.length <= 3) {
      return `${name[0]}**@${domain}`;
    }

    return `${name.slice(0, 2)}${"*".repeat(
      name.length - 3
    )}${name.slice(-1)}@${domain}`;
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!value) {
      setShowHelperText(true);
      setHelperText("Podaj nazwę użytkownika lub email.");
      setSuccess(false);
      return;
    }

    setButtonLabel("Wysyłanie...");

    try {
      const resp = await fetch(
        `${props.state.api_url}/ti/api/password-reset-request/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username_or_email: value }),
        }
      );

      const data = await resp.json();
      if (!resp.ok) {
        setShowHelperText(true);
        setHelperText(data.detail || "Błąd.");
        setButtonLabel("Wyślij link resetujący");
        setSuccess(false);
        return;
      }
      if (resp.ok) {
        setShowHelperText(true);
        setHelperText(`Jeśli konto istnieje, link został wysłany na adres ${obfuscateEmail(data.sent_to)}`);
        setButtonLabel("Wysłano");
        setSuccess(true);

        // Po 5 sekundach przywróć przycisk
        setTimeout(() => {
            setButtonLabel("Wyślij link resetujący");
        }, 3000);
        }
      // ✅ sukces
      setValue("");
      setShowHelperText(true);
      setHelperText(`Jeśli konto istnieje, link został wysłany na adres ${obfuscateEmail(data.sent_to)}`);
      setButtonLabel("Wysłano");
      setSuccess(true);

    } catch (err) {
      setShowHelperText(true);
      setHelperText("Błąd serwera.");
      setButtonLabel("Wyślij link resetujący");
      setSuccess(false);
    }
  };

  const form = (
    <Form onSubmit={handleSubmit}>
      {showHelperText && (
        <Alert
          variant={success ? "success" : "danger"} // ✅ używamy stanu success zamiast resp
          isInline
          title={helperText}
        />
      )}

      <FormGroup label="Nazwa użytkownika lub email" isRequired fieldId="usernameOrEmail">
        <TextInput
          id="usernameOrEmail"
          value={value}
          type="text"
          onChange={(_, v) => setValue(v)}
        />
      </FormGroup>

      <Button
            variant="primary"
            type="submit"
            isDisabled={buttonLabel === "Wysyłanie..." || buttonLabel === "Wysłano"}
        >
            {buttonLabel}
        </Button>
    </Form>
  );

  return (
      <div className="pf-login-wrapper">
        <LoginPage
          // backgroundImgSrc={backgroundImg}
          loginTitle="Ustawienie lub Resetowanie hasła"
          loginSubtitle="Podaj login lub email"
        >
          {form}
          {/* <div style={{ marginTop: "2rem"}}>
            <p style={{ fontSize: "0.8rem", marginTop: "0.5rem", marginBottom: "0.5rem" }}>
              Zeskanuj kod QR, aby ustawić<br /> hasło za pomocą telefonu.
            </p>
            <QRCodeCanvas
              value={currentUrl}
              size={100}
              includeMargin={true}
            />
          </div> */}
          <br />
          <Split hasGutter>
            <SplitItem>
              <QRCodeCanvas
                value={currentUrl}
                size={100}
                includeMargin={true}
              />
            </SplitItem>
            <SplitItem>
              <p style={{ fontSize: "0.8rem", marginBottom: "0.5rem" }}>
                Zeskanuj kod QR, aby ustawić<br /> hasło za pomocą telefonu.
              </p>
            </SplitItem>
          </Split>
        </LoginPage>
      </div>
  );
};

export default PasswordResetRequestPage;